import React, { Fragment, useState, useEffect } from "react";
import { apiJson } from "../../../api/Api";
import { toast } from "react-toastify";
import { Table } from "react-bootstrap";
import { BsThreeDots } from "react-icons/bs";
import { Redirect } from "react-router";
import Dropdown from "rc-dropdown";
import Menu, { Item as MenuItem } from "rc-menu";
import "rc-dropdown/assets/index.css";
import Pagination from "react-paginate";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import ClipLoader from "react-spinners/ClipLoader";

const TableList = (props) => {
  const [receipt, setReceipt] = useState(false);
  const [values, setValues] = useState("");

  useEffect(() => {
    setValues(props.List);
  }, [props.List]);

  const handlePageChange = (pageNumber) => {
    props.pageChange(pageNumber.selected + 1);
  };
  const [orderID, setOrderID] = useState("");
  const [dropdown, setdropdown] = useState({
    value: false,
    id: -1,
  });

  let message = "";

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const menuItems = [
    <MenuItem
      key="1"
      onClick={() =>
        setdropdown({
          value: true,
          id: orderID,
        })
      }
      style={{ cursor: "pointer" }}
    >
      View Details
    </MenuItem>,
    <MenuItem
      key="2"
      onClick={() => !receipt && generaReceipt(orderID)}
      style={{ cursor: "pointer" }}
    >
      Generate Receipt
    </MenuItem>,
    <MenuItem
      key="3"
      onClick={() => !receipt && generatePackingSlip(orderID)}
      style={{ cursor: "pointer" }}
    >
      GeneratePacking Slip
    </MenuItem>,
  ];

  const menu = <Menu className="menu">{menuItems}</Menu>;

  const generaReceipt = (id) => {
    setReceipt(true);
    apiJson.orders.generateOrderReceipt(id).then((response) => {
      if (response.success) {
        const file = response.data;
        const fileURL = URL.createObjectURL(file);
        const popup = window.open(fileURL);
        if (!popup || popup.outerHeight === 0) {
          alert(
            "Popup Blocker is enabled! Please add this site to your exception list."
          );
        } else {
          window.open("", "_self");
          window.close();
        }
        setReceipt(false);
      } else if (!response.status) {
        message = response.message
          ? response.message !== ""
            ? response.message
            : "something went wrong"
          : "something went wrong";
        showError();
      } else {
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
            ? response.errors
            : "something went wrong";
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        }
      }
    });
  };

  const generatePackingSlip = (id) => {
    setReceipt(true);
    apiJson.orders.generatePackingSlip(id).then((response) => {
      if (response.success) {
        const file = response.data;
        const fileURL = URL.createObjectURL(file);
        const popup = window.open(fileURL);
        if (!popup || popup.outerHeight === 0) {
          alert(
            "Popup Blocker is enabled! Please add this site to your exception list."
          );
        } else {
          window.open("", "_self");
          window.close();
        }
        setReceipt(false);
      } else if (!response.status) {
        message = response.message
          ? response.message !== ""
            ? response.message
            : "something went wrong"
          : "something went wrong";
        showError();
      } else {
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
            ? response.errors
            : "something went wrong";
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        }
      }
    });
  };

  return (
    <Fragment>
      <div className="table-responsive">
        <Table hover className="overflow-auto borderless">
          <thead style={{ borderBottom: "#F5F5F9" }}>
            <tr className="table-head">
              <td className="w-10 header-text">Order #</td>
              <td className="w-10 header-text">Items Count</td>
              <td className="w-10 header-text">Customer Email</td>
              <td className="w-10 header-text">Status</td>
              <td className="w-10 header-text">Total Price</td>
              <td className="w-10 header-text">Discount</td>
              <td className="w-10 header-text">Actions</td>
            </tr>
          </thead>

          <tbody>
            {values !== "" &&
              values.map((order) => {
                const id = order.id;
                return (
                  <tr
                    key={order.id}
                    onClick={() =>
                      setdropdown({
                        value: true,
                        id: id,
                      })
                    }
                  >
                    <td className="order-number">{order.id}</td>
                    <td className="items-count">{order.item_count}</td>
                    <td className="email-text">{order.user_email}</td>
                    <td>
                      <div
                        className="status-text"
                        style={{ textTransform: "capitalize" }}
                      >
                        {order.status && order.status.includes("_")
                          ? order.status.replace("_", " ")
                          : order.status}
                      </div>
                    </td>
                    <td className="total-price-text">{order.total_price}</td>
                    <td className="discount-price-text">{order.discount}</td>
                    <td
                      className="w-10 header-text"
                      onClick={(e) => e.stopPropagation()}
                    >
                      {" "}
                      <Dropdown
                        className="dropdown-for-send"
                        overlay={menu}
                        overlayClassName="overlay-class"
                      >
                        <BsThreeDots
                          style={{ pointerEvents: "visibleStroke" }}
                          onMouseEnter={() => !receipt && setOrderID(id)}
                          onClick={() => !receipt && setOrderID(id)}
                        />
                      </Dropdown>
                      {receipt && id === orderID && (
                        <div className="d-flex justify-content-center align-items-center">
                          <ClipLoader color="#000" loading size={15} />
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </Table>
        {dropdown.value && (
          <Redirect
            push
            to={{
              pathname: `/vendor/order-detail/${dropdown.id}`,
              state: { name: "view", id: dropdown.id },
            }}
          />
        )}
      </div>
      {props.pagination?.total_pages && values.length > 0 && (
        <div
          className="d-flex justify-content-center mb-4 w-100"
          style={{ direction: "ltr" }}
        >
          <Pagination
            direction="ltr"
            previousLabel={<FaChevronLeft color="#404553" />}
            nextLabel={<FaChevronRight color="#404553" />}
            pageCount={props.pagination?.total_pages}
            onPageChange={handlePageChange}
            pageRangeDisplayed={2}
            forcePage={parseInt(props?.pagination?.page) - 1}
            containerClassName="pagination"
            pageClassName="ps-3 pe-3 pt-2 pb-2"
            activeClassName={
              "ms-3 me-3 ps-1 pe-1 text-primary border border-primary font-weight-bold rounded bg-white"
            }
            nextClassName="bg-white ps-3 pe-3 pt-2 pb-2"
            previousClassName="bg-white ps-3 pe-3 pt-2 pb-2"
          />
        </div>
      )}
    </Fragment>
  );
};

export default TableList;
